"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WstEthOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var WstEthOracleFactory = /** @class */ (function (_super) {
    __extends(WstEthOracleFactory, _super);
    function WstEthOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    WstEthOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    WstEthOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    WstEthOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    WstEthOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    WstEthOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return WstEthOracleFactory;
}(contracts_1.ContractFactory));
exports.WstEthOracleFactory = WstEthOracleFactory;
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "chainLinkEthAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainlinkEthScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stETHCrvPoolAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "wstETHAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
